import { render, staticRenderFns } from "./PesquisaMercado.vue?vue&type=template&id=d503b7ec&scoped=true"
import script from "./PesquisaMercado.vue?vue&type=script&lang=js"
export * from "./PesquisaMercado.vue?vue&type=script&lang=js"
import style0 from "./PesquisaMercado.vue?vue&type=style&index=0&id=d503b7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d503b7ec",
  null
  
)

export default component.exports